import { currentVersion } from '../app/appVersion';
export const environment = {
  googleAnalyticsMeasurementId: 'G-4G1VE1QGMY',
  production: false,
  baseUrl: window.location.origin + '/api/radial',
  rucUrl: window.location.origin + '/api/ruc',
  pingUrl: window.location.origin + '/api/ping/userinfo',
  generateReportUrl:
    'https://radial.legacy-st1.bpost.cloud/generatereport/',
  qlikViewGraphUrl:
    window.location.origin + '/api/radial/clientbaselinereports',
  cbrGraphUrl: window.location.origin + '/api/radial/clientbaselinereports',
  clientConfigUrl: window.location.origin + '/api/radial/clientconfig/',
  userConfigUrl: window.location.origin + '/api/radial/userconfig/',
  reportUrl: 'https://datawarehouse-report.s3.eu-west-1.amazonaws.com/',
  claimUrl: 'https://datawarehouse-report.s3.eu-west-1.amazonaws.com',
  logout: 'https://login.bpost.be/idp/startSLO.ping',
  rootUrl: 'https://radial-st1.bpost.cloud',
  downloadRootUrl: 'https://radial.legacy-st1.bpost.cloud',
  VERSION: currentVersion,
  DEPLOYED_BRANCH_NAME: 'st(ed5f0e48b793717db9c440b5c48d4cff654acfff)',
  DEPLOYED_BRANCH_URL: 'https://bitbucket.org/bpost_deliveryparcelsint/rcp-frontend-v2/commits/ed5f0e48b793717db9c440b5c48d4cff654acfff',
  PBI_TRANSPORT_DASHBOARD_REPORTID: 'e12bbd75-ed4f-4e3d-ba3f-62342632a4c6',
  PBI_TRANSPORT_DASHBOARD_WORKSPACEID: 'e55cbf51-acfa-4d2f-b9d7-43579edbcca5',
  PBI_PAXON_DASHBOARD_REPORTID: 'd3c73909-5072-4add-ac77-4db746f4fe73',
  PBI_PAXON_DASHBOARD_WORKSPACEID: 'e55cbf51-acfa-4d2f-b9d7-43579edbcca5',
};
